import useSWR from "swr"

import { SupplyPhases } from "../../../../components/submitApplication/single/types/formGeneratorTypes"
import { Datasets } from "../../../../constants/enums"
import { AppError, parseErrorAsObj } from "../../../../errors/errorProcessors"
import { snackbar } from "../../../../utils/general/generalUtils"
import { getClientProtected } from "../../clients/clients"
import { searchLctMapper } from "../../mappers/singleApplication/searchLctMapper"
import { NO_REVALIDATE_CONFIG } from "../../swrConfig"
import { IDeviceSearchResult } from "../../types/singleApplication/searchLctTypes"
import { SUGGEST_DEVICE } from "../../urls/hybrid"

const MIN_SEARCH_TERM_LENGTH = 3

export interface IUseSearchLct {
    data: IDeviceSearchResult[] | undefined
    isLoading: boolean
    isError: boolean
}

/** Suggestion API for LCT devices */
const useSearchLct = (
    searchTerm: string,
    deviceType: string,
    dataset: Datasets,
    jurisdiction: string,
    phases?: SupplyPhases
): IUseSearchLct => {
    const { data, error, isLoading } = useSWR(
        searchTerm.length < MIN_SEARCH_TERM_LENGTH
            ? null
            : SUGGEST_DEVICE(
                  searchTerm,
                  deviceType,
                  dataset,
                  jurisdiction,
                  phases
              ),
        async (url: string): Promise<IDeviceSearchResult[]> => {
            try {
                const res = await getClientProtected(url)
                return searchLctMapper.map(res)
            } catch (err) {
                const errorObj = parseErrorAsObj(err)
                // Assumed to be an error that cam be resolved by the user
                // continuing to type. Hecne no error is flagged
                if (errorObj.code === 400) {
                    return []
                }
                snackbar(
                    "Something went wrong with your device search. Please try again",
                    "warning"
                )
                // Throw generic app error
                throw new AppError(
                    "Search device failed in create application form",
                    400,
                    "Not displayed",
                    "Not displayed",
                    "warning"
                )
            }
        },
        NO_REVALIDATE_CONFIG
    )

    return {
        data,
        isLoading,
        isError: !!error,
    }
}

export default useSearchLct
